import React from 'react';
import { bool, string } from 'prop-types';
import { injectIntl, intlShape } from '../../util/reactIntl';

import SortByPlain from './SortByPlain';
import SortByPopup from './SortByPopup';

const LongTermSortBy = props => {
  const { sort, showAsPopup, isKeywordFilterActive, intl, sortConfig = null, ...rest } = props;

  const { relevanceKey } = sortConfig;

  const options = sortConfig.options.map(option => {
    const isRelevance = option.key === relevanceKey;
    return {
      ...option,
      disabled: isKeywordFilterActive,
    };
  });
  const defaultValue = 'relevance';

  const componentProps = {
    urlParam: 'sort',
    label: intl.formatMessage({ id: 'SortBy.heading' }),
    options,
    initialValue: isKeywordFilterActive ? relevanceKey : sort || defaultValue,
    ...rest,
  };

  return showAsPopup ? <SortByPopup {...componentProps} /> : <SortByPlain {...componentProps} />;
};

LongTermSortBy.defaultProps = {
  sort: null,
  showAsPopup: false,
};

LongTermSortBy.propTypes = {
  sort: string,
  showAsPopup: bool,
  isKeywordFilterActive: bool.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(LongTermSortBy);
